import { render, staticRenderFns } from "./AzSubmit.vue?vue&type=template&id=2fb7b395&"
import script from "./AzSubmit.vue?vue&type=script&lang=js&"
export * from "./AzSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports